export const CHANGE_DIALER_VALUE = 'dialer/CHANGE_DIALER_VALUE';

export const changeDialerValue = value => ({
  type: CHANGE_DIALER_VALUE,
  payload: { value },
});
